export enum QueryType {
    Detail = "detail",
    List = "list",
    PagedList = "pagedList",
}
